import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";

// redux
import { useSaveUploadsForLater } from "../../../../../hooks";
import { openLargeImageView } from "../../../../../slices/largeImageViewSlice.js";
import {
    blurUpload,
    unblurUpload
} from "../../../../../slices/uploadFooterActionsSlice";

// styles
import { FooterStyled } from "./styles.js";

// components
import ModerationToggleBand, {
    Heart,
    MatureAudience,
    Divider,
    Clock,
    Eye,
    Expand
} from "frontend/components/fort/mod/core/ModerationToggleBand";

// config
import * as Config from "frontend/components/fort/mod/photos/config.js";

import {
    SET_GEM_STATUS_ON_UPLOADS,
    SET_MATURE_ON_UPLOADS
} from "../../../../../mutations";

const Footer = ({ upload, isDisabled }) => {
    const dispatch = useDispatch();
    const { handleSaveForLaterToggle } = useSaveUploadsForLater();

    const { id } = upload;
    const footerActions =
        useSelector(state => state.uploadFooterActions.entities[id]) || {};

    const [setGemStatus] = useMutation(SET_GEM_STATUS_ON_UPLOADS);
    const [setMatureStatus] = useMutation(SET_MATURE_ON_UPLOADS);

    // Save For Later
    const onSaveForLaterToggle = () => {
        handleSaveForLaterToggle([upload.id]);
    };

    const onHeartToggle = ({ isActivated }) => {
        setGemStatus({
            variables: {
                photoUploadIds: [upload.id],
                value: isActivated
            }
        });
    };

    const onMatureToggle = ({ isActivated }) => {
        setMatureStatus({
            variables: {
                photoUploadIds: [upload.id],
                value: isActivated
            }
        });
    };

    const onEyeToggle = ({ isActivated }) => {
        isActivated
            ? dispatch(blurUpload(upload.id))
            : dispatch(unblurUpload(upload.id));
    };

    // Expand Modal
    const onExpandToggle = ({ isActivated }) => {
        if (isActivated) {
            dispatch(openLargeImageView([id]));
        }
    };

    return (
        <FooterStyled>
            <ModerationToggleBand>
                <Heart
                    isDisabled={isDisabled || upload.creatorIsPremium}
                    isActivated={footerActions[Config.moderatorIconKeys.HEART]}
                    moderationIconKey={Config.moderatorIconKeys.HEART}
                    onToggle={onHeartToggle}
                />
                <MatureAudience
                    isActivated={
                        footerActions[Config.moderatorIconKeys.MATURE_AUDIENCE]
                    }
                    moderationIconKey={Config.moderatorIconKeys.MATURE_AUDIENCE}
                    isDisabled={isDisabled}
                    onToggle={onMatureToggle}
                />
                <Divider />
                <Clock
                    isActivated={
                        footerActions[Config.moderatorIconKeys.SAVE_FOR_LATER]
                    }
                    moderationIconKey={Config.moderatorIconKeys.SAVE_FOR_LATER}
                    isDisabled={isDisabled}
                    onToggle={onSaveForLaterToggle}
                    testId={`mod-band-save-for-later-${id}`}
                />
                <Eye
                    isActivated={footerActions[Config.moderatorIconKeys.BLUR]}
                    moderationIconKey={Config.moderatorIconKeys.BLUR}
                    isDisabled={isDisabled}
                    onToggle={onEyeToggle}
                />
                <Expand
                    isActivated={footerActions[Config.moderatorIconKeys.EXPAND]}
                    moderationIconKey={Config.moderatorIconKeys.EXPAND}
                    isDisabled={isDisabled}
                    onToggle={onExpandToggle}
                />
            </ModerationToggleBand>
        </FooterStyled>
    );
};

export default Footer;

// prop-types
Footer.propTypes = {
    upload: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool.isRequired
};
